import { CountryHelper } from "app/helpers/countryHelper";
import { ResponsiveScreenSizesInt, SUPPORTEDLANGUAGES } from "app/utils/const";
import { memo, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import brFlag from "../../images/flags/br.svg";
import cnFlag from "../../images/flags/cn.svg";
import esFlag from "../../images/flags/es.svg";
import gbFlag from "../../images/flags/gb.svg";
import ptFlag from "../../images/flags/pt.svg";
import wwFlag from "../../images/flags/WW.svg";
import "./LanguageSelector.scss";

const LanguageSelector = memo(
  ({ onLanguageChangeRequest, locale, small = false }) => {
    const handleChange = selectedOptionValue => {
      onLanguageChangeRequest(selectedOptionValue);
    };
    const [isMobile, setIsMobile] = useState(
      window.innerWidth <= ResponsiveScreenSizesInt.mobile
    );

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= ResponsiveScreenSizesInt.mobile);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const options = SUPPORTEDLANGUAGES.filter(lang => lang.active).map(
      lang => ({
        value: lang.locale,
        label: small ? lang.shortLabel : lang.label,
        flagCode: CountryHelper.getCountryCodeForFlagFromLocale(lang.locale),
      })
    );

    const getFlag = data => {
      switch (data.flagCode) {
        case "ES":
          return esFlag;
        case "CN":
          return cnFlag;
        case "GB":
          return gbFlag;
        case "PT":
          return ptFlag;
        case "BR":
          return brFlag;
        default:
          return wwFlag;
      }
    };

    const selectedOption = options.find(option => option.value === locale);

    const CustomOption = ({ innerProps, isDisabled, data }) => {
      if (isDisabled) return null;

      return (
        <div {...innerProps}>
          <img
            src={getFlag(data)}
            alt="Flag"
            style={{ width: 10, height: 10, marginRight: 5, marginTop: 7 }}
          />
          <span
            className={`language-selector-${
              small ? "small" : "wide"
            }__flag-text`}
          >
            {data.label}
          </span>
        </div>
      );
    };

    const CustomSingleValue = ({ innerProps, data }) => (
      <span {...innerProps}>
        <img
          src={getFlag(data)}
          alt="Flag"
          style={{ width: 10, height: 10, marginRight: 5, marginLeft: 2 }}
        />
        {/* To show more compact verion when showing on small screens */}
        {/* Don't show the language name, only the flag */}
        {!isMobile && (
          <span
            className={`language-selector-${
              small ? "small" : "wide"
            }__flag-text`}
          >
            {data.label}
          </span>
        )}
      </span>
    );

    return (
      <div className={`language-selector--${small ? "small" : "x"}`}>
        {small ? null : (
          <label
            className="language-selector__label"
            htmlFor="language_type_dropdown"
          >
            <FormattedMessage tagName="span" id="settings-language" />
          </label>
        )}
        <Select
          value={selectedOption}
          onChange={e => e && e.value && handleChange(e.value)}
          options={options}
          id="language_type_dropdown"
          className={`language-selector-${
            small ? "small-container" : "wide-container"
          }`}
          classNamePrefix={`language-selector-${small ? "small" : "wide"}`}
          isSearchable={false}
          components={{ SingleValue: CustomSingleValue, Option: CustomOption }}
          // menuIsOpen={true} // set this to keep menu open for debugging etc
          unstyled
        />
      </div>
    );
  }
);

export default LanguageSelector;
